import React from 'react';
import Card from '../../components/ui/Card';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export default function EntraidePage() {
  const pieces = [
    "Passeport : Copies légalisées (infos + cachet d'entrée)",
    "Justificatif de domicile : Bail ou certificat d'hébergement (légalisé)",
    "Attestation d'inscription ou de scolarité (légalisée)",
    "Attestation de bourse ou prise en charge (légalisée)",
    "Casier judiciaire original (pays d'origine)",
    "Certificat médical (délivré au Maroc)",
    "6 à 7 photos d'identité format carte de séjour",
    "100 DH de frais de timbre par année de validité"
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-8 animate-fade-in px-4">
      <div className="text-center space-y-2">
        <h1 className="font-title text-3xl sm:text-4xl font-extrabold text-acem-primary-dark">
          Démarches Administratives
        </h1>
        <p className="text-sm sm:text-base text-acem-muted">
          Guide complet pour l'obtention et le renouvellement de votre carte de séjour d'étudiant étranger à Fès.
        </p>
      </div>

      {/* Alerte 90 jours */}
      <div className="bg-emerald-50/70 p-5 rounded-xl border border-emerald-100 space-y-2">
        <h3 className="font-bold text-acem-primary text-base flex items-center gap-2">
          La Carte de Séjour : L'essentiel à retenir
        </h3>
        <p className="text-xs sm:text-sm text-acem-text leading-relaxed">
          Une fois arrivé au Maroc, vous disposez d'un délai de <strong>90 jours</strong> pour entamer les démarches de régularisation de votre séjour auprès de la préfecture de police. Dépasser ce délai vous place en situation d'irrégularité. Il est fortement recommandé de constituer votre dossier dès les premières semaines.
        </p>
      </div>

      <div className="space-y-6">
        {/* Étape 1 */}
        <Card variant="elevated" className="p-6 sm:p-8 space-y-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-acem-primary text-white font-title text-xl font-bold flex items-center justify-center flex-shrink-0 shadow-sm">
              1
            </div>
            <h3 className="font-title text-lg sm:text-xl font-bold text-acem-text">
              Constitution du dossier (Première demande)
            </h3>
          </div>

          <p className="text-xs sm:text-sm text-acem-muted">
            Le dossier complet doit être déposé en personne au service des étrangers de la préfecture de police de Fès.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            {pieces.map((piece, idx) => (
              <div
                key={idx}
                className="flex items-start gap-2.5 bg-acem-surface-container-low p-3.5 rounded-xl border border-acem-border/50 text-xs sm:text-sm text-acem-text"
              >
                <CheckCircleIcon className="w-4 h-4 text-acem-primary flex-shrink-0 mt-0.5" aria-hidden="true" />
                <span>{piece}</span>
              </div>
            ))}
          </div>
        </Card>

        {/* Étape 2 */}
        <Card variant="elevated" className="p-6 sm:p-8 space-y-3">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-acem-primary text-white font-title text-xl font-bold flex items-center justify-center flex-shrink-0 shadow-sm">
              2
            </div>
            <h3 className="font-title text-lg sm:text-xl font-bold text-acem-text">
              Cas du Renouvellement
            </h3>
          </div>

          <p className="text-xs sm:text-sm text-acem-text/90 leading-relaxed">
            Pour renouveler votre carte, les pièces requises sont identiques à l'exception du casier judiciaire : vous devez fournir le <strong>casier judiciaire marocain (fiche anthropométrique)</strong>, qui se demande en ligne sur le{' '}
            <a
              href="https://casierjudiciaire.justice.gov.ma/Accueil.aspx?culture=fr-FR"
              target="_blank"
              rel="noopener noreferrer"
              className="text-acem-primary font-bold hover:underline"
            >
              portail officiel du Ministère de la Justice
            </a>.
          </p>
          <p className="text-xs sm:text-sm text-acem-muted">
            Frais de timbre : 100 DH pour 1 an, 200 DH pour 2 ans, et 300 DH pour 3 ans de validité.
          </p>
        </Card>

        {/* Étape 3 */}
        <Card variant="elevated" className="p-6 sm:p-8 space-y-3">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-acem-primary text-white font-title text-xl font-bold flex items-center justify-center flex-shrink-0 shadow-sm">
              3
            </div>
            <h3 className="font-title text-lg sm:text-xl font-bold text-acem-text">
              Dépôt et Récépissé
            </h3>
          </div>

          <p className="text-xs sm:text-sm text-acem-text/90 leading-relaxed">
            Lors du dépôt à la préfecture, un agent vous remettra un <strong>récépissé officiel</strong>. Ce document certifie la régularité de votre séjour en attendant la délivrance de votre carte définitive (délai moyen de 4 à 6 semaines).
          </p>
        </Card>
      </div>

      {/* Support Box */}
      <Card variant="default" className="p-5 flex items-start gap-4 text-xs sm:text-sm text-acem-muted">
        <div>
          <strong className="text-acem-text font-bold">Besoin d'aide ou d'orientation ?</strong> Si vous rencontrez des difficultés administratives particulières, rapprochez-vous du bureau de l'ACEM Fès pour être guidé et accompagné dans vos démarches.
        </div>
      </Card>
    </div>
  );
}
